export default __webpack_public_path__ + "static/media/compliance-2023.f56b0536.jpg";